import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-h1-icon',
  templateUrl: './text-h1.component.html'
})
export class TextH1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
